import { LinkCellData } from '@widgets/innogy-data-table/link-cell/link-cell.component';
import {
  ButtonConfig,
  CellType,
} from '@widgets/innogy-data-table/dynamic-cell/dynamic-cell.component';

export interface ReceiptsTableData {
  paging: ReceiptPaging;
  data: ReceiptTableEntry[];
}

export interface Partners {
  businessPartners: Partner[];
}

export interface Partner {
  id: string;
  name: string;
}

export interface ReceiptsResponse {
  paging: ReceiptPaging;
  receipts: Receipt[];
}

export interface Receipt {
  id: string;
  sessionStart: string;
  terminalId: string;
  transactionId: string;
  cardNumber: string;
  cardType: string;
  totalPrice: number;
  currency: string;
  chargePortName: string;
  stationId: string;
  created: string;
  maskedEmail: string;
  downloadId: string;
}

export interface ReceiptPaging {
  itemsPerPage: number;
  currentPage?: number;
  totalItems?: number;
  totalPages?: number;
}

export interface ReceiptTableEntry extends ReceiptCsvEntry {
  id: string;
  download: {
    cellType: CellType;
    buttonConfig: ButtonConfig;
  };
  downloadId: string;
}

export interface ReceiptCsvEntry {
  startTimestamp: string;
  terminalId?: string;
  transactionId: string;
  cardNumberSuffix: string;
  cardType: string;
  totalAmount: string;
  chargepointId: string | LinkCellData;
  createdAt: string;
  email?: string;
}

export interface ReceiptsUiFilter {
  cardNumberSuffix?: string;
  cardType?: string;
  chargePortName?: string;
  sessionStartFrom?: string;
  sessionStartTo?: string;
  terminalId?: string;
  transactionId?: string;
  email?: string;
}

export interface ReceiptFilter extends ReceiptsUiFilter {
  page?: number;
  itemsPerPage?: number;
  sortColumn?: string;
  sortOrder?: string;
}

export interface ReceiptFile {
  filename: string;
  fileContent: string;
}

export interface ExportReceiptsPayload {
  terminalId: string;
  transactionId: string;
  cardNumberSuffix: string;
  cardType: string;
  chargepointId: string;
  startTimestampFrom: string;
  startTimestampTo: string;
}

export interface ExportStatus {
  state: ZipExportState;
  countAll: number;
  countCurrent: number;
  filename: string;
  downloadId: string;
}

export enum ZipExportState {
  CREATED = 'CREATED',
  PROCESSING = 'PROCESSING',
  FINISHED = 'FINISHED',
  FAILED = 'FAILED',
}

export enum ReceiptType {
  DIRECT_PAYMENT = 'DIRECT_PAYMENT',
  PAYMENT_TERMINAL = 'PAYMENT_TERMINAL',
}
